export default {
    _home: '首页',
    home: '首页',

    'i18n-tip': '注：仅此页做了多语言，其他页面没有在多语言包中添加语言内容',

    // 市场管理
    scinfo: '市场管理',
    sc_market: '市场信息管理',
    scinfo_jobfair: '招聘会管理',
    scinfo_room: '面试室管理',

    // 企业管理
    company: '企业管理',
    company_info: '企业信息管理',
    company_job: '职位管理',
    company_audit: '企业审核管理',

    // 求职者管理
    person: '求职者管理',
    person_info: '求职者信息管理',
    person_tocompany: '求职管理',

    // 劳务派遣用工登记
    dispatch: '劳务派遣用工登记',
    dispatch_info: '派遣机构管理',
    dispatch_person: '用工管理',
    dispatch_all: '用工情况查询',

    // 企业服务
    company_other: '企业服务',
    tcrc_zm: '芝麻背调',
    js_zhy: '江苏省智慧就业云平台',

    // 信息管理
    account: '信息管理',
    account_company_info: '基础信息管理',

    // 招聘管理
    apply: '招聘管理',
    apply_jobfair: '招聘会',
    apply_online: '在线面试',
    apply_job: '职位管理',
    apply_application: '应聘管理',

    // 调查问卷管理
    survey_manage: '调查问卷管理',
    survey_list: '问卷调查管理',

    // 活动（子页）
    activity_company_list: '企业管理',
    activity_company_job_list: '职位管理',

    // 简章
    jianzhang: '简章',
    jianzhang_list: '简章管理',
    jianzhang_applies: '报名记录',

    // 通用页面
    login: 'Login - 登录',
    gzh: '办事大厅',
    resume: '个人简历',
    led_screen: 'LED大屏',
    led_recruitment_stats: '招聘数据统计大屏',
    error_403: '无权限',
    error_500: '服务器错误',

    // 专区管理
    special_area: '专区管理',
    soldier_job: '退役军人_职位',
    soldier_person: '退役军人_个人',
    soldier_person_tocompany: '退役军人_求职',
    soldier_jobfair: '退役军人_招聘会',
    cripple_stall: '残疾人_摊位设置',
    cripple_job: '残疾人_职位',
    cripple_person: '残疾人_个人',
    cripple_person_tocompany: '残疾人_求职',
    cripple_jobfair: '残疾人_招聘会',

    // 报表管理
    report: '报表管理',
    report_company: '单位信息汇总表',
    report_job: '职位信息汇总表',
    report_jobfair: '市场信息统计表',
    report_statistics: '市场汇总统计表',
    report_jobfair_signin: '市场签到表',
    report_supply_mon: '月度供求统计表',
    report_place: '安置就业',

    // 用户管理
    usermanage: '用户管理',
    user: '用户列表',
    user_behavior: '用户行为记录',
    menus: '菜单组件',
    role: '角色管理',
    account_delete: '账户注销',

    // 系统管理
    system: '系统管理',
    home_module: '首页模块管理',
    third_party_api: '第三方API配置',
    sys_parameter: '参数设置',
    upload_config: '上传设置',
    parameter_merge: '参数清理',

    // 设备管理
    equipment: '设备管理',
    equipment_manage: '设备列表',
    update_package: '更新包管理',

    // 公告管理
    announcement: '公告管理',
    announcement_list: '公告列表',
    announcement_category: '公告分类管理',

    // 活动
    activity: '活动',
    voteshow: '投票',
    activity_list: '活动管理',

    // 人力资源
    hr_bussiness: '人力资源',
    hr_bussiness_info: '求职跟踪服务',
    hr_bussiness_config: '业务设置',

    // 援助人员管理
    assist: '援助人员管理',
    assist_person: '援助人员信息管理',
    assist_out: '援助情况反馈',
    assist_parameter: '参数管理',

    // 援助服务
    assist_s: '援助服务',
    assist_server: '援助服务',
    assist_kpi: '援助服务再分配',

    // 乐就小程序
    ljtc: '乐就小程序',
    school_jobfair: '高校网络招聘会',
    personnelapplyconfig: '预约设置',

    // 人才编码
    personnel: '人才编码',
    personnelapply: '预约记录',

    // 医疗保障
    allopatry: '医疗保障',
    allopatryinfo: '居外就医申请',

    // 安全设置
    security: '安全设置',
    security_ip: 'IP黑白名单',
    security_access: '访问情况',
    security_sensitive_word: '敏感词设置',
    security_sensitive_field: '敏感字段设置',
    security_skip_path: '路径白名单',

    // 在线沟通
    chat: '在线沟通',
    chat_index: '在线沟通',
}